import { Ref, Component } from '@eastsideco/salvo-ts';
import { ThemeComponent } from '@/theme/ThemeComponent';

@Component
export class ReadMore extends ThemeComponent {

    @Ref({ required: false }) button!: HTMLButtonElement;

    init() {
        if (this.button) {
            this.$listen(this.button, 'click', () => {
                if (this.classList.contains('read-more--active')) {
                    this.classList.remove('read-more--active');
                    this.button.innerText = 'Read more';
                } else {
                    this.classList.add('read-more--active');
                    this.button.innerText = 'Read less';
                }
            });
        }
    }
}
